<template>
  <div class="page_injuryTables">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px">
            <el-form-item label="姓名" size="small">
              <el-input v-model="listQuery.injuredEmployeeName" size="small" clearable style="width: 180px;"></el-input>
            </el-form-item>
            <el-form-item label="身份证号码" size="small">
              <el-input v-model="listQuery.idcard" size="small" clearable style="width: 180px;"></el-input>
            </el-form-item>
            <el-form-item label="项目名称" size="small">
              <el-select v-model="listQuery.projectName" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box" style="padding-left: 29px;">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px" size="small">
          <el-form-item label="工伤开始时间">
            <el-date-picker v-model="listQuery.startimeInjury" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="工伤结束时间">
            <el-date-picker v-model="listQuery.endimeInjury" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="员工手机号">
            <el-input v-model="listQuery.employeePhone" size="small" clearable style="width:180px"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>报案理赔</el-breadcrumb-item>
          <el-breadcrumb-item>工伤事故报告</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane :label="'草稿（' + num0 + ')'" name="0"></el-tab-pane>
          <el-tab-pane :label="'工伤事故报告（' + num1 + ')'" name="1"></el-tab-pane>
          <el-tab-pane :label="'退回待处理（' + num2 + ')'" name="2"></el-tab-pane>
          <el-tab-pane :label="'申请修改（' + num3 + ')'" name="3"></el-tab-pane>
          <el-tab-pane :label="'客服主管审批（' + num5 + ')'" name="5"></el-tab-pane>
          <el-tab-pane :label="'商保审批（' + num6 + ')'" name="6"></el-tab-pane>
          <el-tab-pane :label="'社保审批（' + num7 + ')'" name="7"></el-tab-pane>
          <el-tab-pane :label="'审批完成（' + num4 + ')'" name="4"></el-tab-pane>
        </el-tabs>
        <div class="ftabBtn flex">
          <el-button type="success" size="small" @click="addNewAcd">&nbsp;新增+</el-button>
          <el-button type="warning" size="small" @click="ImportSocialCompanyName">社保账户对应工伤负责人导入</el-button>
          <el-button type="primary" size="small" v-if="activeName=='4'" @click="expList">批量导出</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%">
          <el-table-column prop="Sort" label="序号" width="50" align="center" fixed="left">
            <template slot-scope="scope">
              {{(listQuery.pageModel.page - 1) * Number(listQuery.pageModel.rows)  + scope.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column prop="idcard" label="身份证号码" width="160" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="injuredEmployeeName" label="工伤员工姓名" width="100" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="projectName" label="项目名称" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="service" label="客服" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="servicePhone" label="客服联系电话" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="branchOffice" label="立项归属公司" width="110" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="mainBusiContract" label="主商务合同（法务主体）全称" width="200" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="timeInjury" label="发生工伤日期" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="timeInjury1" label="发生工伤时间点" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="employeeEduc" label="员工学历" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="employeePhone" label="员工联系电话" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="fullNameCustomer" label="客户单位全称" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="customerAddress" label="客户单位地址" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="unjuryAddress" label="发生事故地址" width="180" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="partyLaborContract" label="劳动合同公司" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="positionInjury" label="工伤发生时岗位" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="injuryDetails" label="事故经过" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="approximateCost" label="大致费用" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="fullNameFirstHospital" label="首次就诊医院全称" width="130" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="diagnosis" label="诊断结论" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="doctorAdvice" label="医生建议" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="insurePosition" label="商保参保时岗位" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="insureCategory" label="商保参保时职业类别" width="150" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="isHospitalized" label="是否住院" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="injuryDegree" label="工伤程度" width="90" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="isTrafficInjury" label="是否交通事故" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="liabilityJudTrafficInjury" label="交通事故员工的责任判定" width="180" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="workplaceInjuryPlace" label="工伤发生地（省市）" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="fullNameSocialSecurity" label="第一申报方（社保全称）" width="170" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="inInsureTime" label="参保时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="secondApplicant" label="第二申报方（商保1）" width="170" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="inInsureTime2" label="参保时间" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="thirdReporting" label="第三申报方（商保2）" width="170" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="inInsureTime3" label="参保时间" width="120" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column prop="injuryEmpAddress" label="工伤事故报告备注" width="140" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column prop="remark" label="工伤事故报告备注" width="170" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column prop="injuryEmpAddress" label="工伤员工居住(收件)地址" width="170" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column prop="submitTime" label="提交时间" width="160" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>
              {{ row.submitTime ? row.submitTime.replace('T',' ') : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="updataTime" label="审批时间" width="160" :show-overflow-tooltip="true" align="center" v-if="activeName=='4'">
            <template slot-scope={row}>
              {{ row.updataTime ? row.updataTime.replace('T',' ') : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="reasonReturn" label="退回原因" v-if="activeName=='2'" width="140" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column label="操作" align="center" fixed="right" :width="activeName== '5' || activeName== '6' || activeName== '7' ? '320px' : '280px'">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" @click="editAcd(row)" v-if="activeName=='0' || activeName=='1' || activeName=='2'">编辑</el-button>
                <el-button type="text" @click="preview(row)">报告预览</el-button>
                <el-button type="text" @click="getReport(row)">导出报告</el-button>
                <el-button type="text" @click="submitHandle(row)" v-if="activeName=='1' || activeName=='2'">提交</el-button>
                <el-button type="text" @click="applyEdit(row)" v-if="activeName=='5' || activeName=='6' || activeName=='7'">申请修改</el-button>
                <el-button type="text" @click="approveHandle(row,'pass')" v-if="activeName=='3'|| activeName=='5' || activeName=='6'|| activeName=='7'">{{ activeName=='3' ? '同意修改' : '审批通过' }}</el-button>
                <el-button type="text" @click="approveHandle(row,'notpass')" v-if="activeName=='3' && checkPermission(['applyModify-return'], permissionLists)">退回</el-button>
                <el-button type="text" @click="approveHandle(row,'notpass')" v-if="activeName=='5' || activeName=='6'|| activeName=='7'">退回</el-button>
                <el-popconfirm :title="'请确定身份证为' + row.idcard + ' 的事故报告作废？'" @confirm="delAcd(row)" style="margin-left: 10px;" v-if="activeName=='0' ||activeName=='1' || activeName=='2'">
                  <el-button type="text" slot="reference">作废</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageModel.page" :page-size="Number(listQuery.pageModel.rows)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog :title="type=='add' ? '新增' : '编辑'" :visible.sync="showAdd" width="1050px">
      <div class="formData">
        <el-form :model="formData" :inline="true" ref="formData" :rules="rules" label-width="170px">
          <el-form-item label="身份证号码" prop="Idcard">
            <el-input v-model.trim="formData.Idcard" style="width:300px" size="small" @blur="getIdcardInfo"></el-input>
          </el-form-item>
          <el-form-item label="工伤员工姓名" prop="InjuredEmployeeName">
            <el-input v-model="formData.InjuredEmployeeName" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="项目名称" prop="ProjectName">
            <el-select v-model="formData.ProjectName" placeholder="" value-key="Projectid" size="small" style="width: 300px;" clearable filterable>
              <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户单位全称" prop="FullNameCustomer">
            <el-input v-model="formData.FullNameCustomer" style="width:300px" size="small"></el-input>
          </el-form-item>
          <div>
            <el-form-item prop="BranchOffice">
              <template #label>
                <span>立项归属公司
                  <!-- <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>“提交表单人员”自己所在（归属）的公司。</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip> -->
                </span>
              </template>
              <el-input v-model="formData.BranchOffice" style="width:300px" size="small"></el-input>
            </el-form-item>
          </div>
          <el-form-item label="客服" prop="Service">
            <el-input v-model="formData.Service" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="客服联系电话" prop="ServicePhone">
            <el-input v-model="formData.ServicePhone" style="width:300px" size="small"></el-input>
          </el-form-item>

          <el-form-item prop="MainBusiContract">
            <template #label>
              <span>主商务合同（法务主体）全称
                <!-- <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div class="agg">“主商务合同（法务主体）”，即与“客户单位”合作的“我司抬头”，亦是“（费用）隶属公司”。</div>
                    <div>例如：宁波英普瑞特供应链管理有限公司/宁波杰博人力资源有限公司等</div>
                    <div class="tipsItem agg">注：“杰博体系自有员工”根据实际“发薪公司”填写。</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip> -->
              </span>
            </template>
            <el-select v-model="formData.MainBusiContract" placeholder="" clearable filterable style="width:300px" size="small">
              <el-option v-for="(item,index) in legList" :key="index" :label="item.CompanyName" :value="item.CompanyName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="PartyLaborContract">
            <template #label>
              <span>劳动合同公司
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>全称</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-select v-model="formData.PartyLaborContract" placeholder="" clearable size="small" style="width:300px" filterable>
              <el-option v-for="(item,index) in legList2" :key="index" :value="item.CompanyName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发生工伤日期" prop="TimeInjury">
            <el-date-picker type="date" placeholder="" v-model="formData.TimeInjury" value-format="yyyy-MM-dd" style="width:300px" size="small" @change="getInjuryDetails"></el-date-picker>
          </el-form-item>
          <el-form-item label="发生工伤时间" prop="TimeInjury1">
            <el-time-picker v-model="formData.TimeInjury1" format="HH:mm" value-format="HH:mm" size="small" placeholder="" style="width:300px" @change="getInjuryDetails">
            </el-time-picker>
          </el-form-item>

          <el-form-item label="员工联系电话" prop="EmployeePhone">
            <el-input v-model="formData.EmployeePhone" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="员工学历" prop="EmployeeEduc">
            <el-input v-model="formData.EmployeeEduc" style="width:300px" size="small"></el-input>
          </el-form-item>

          <el-form-item prop="CustomerAddress">
            <template #label>
              <span>发生事故地址（单位内）
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>详细地址精确到门牌号</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="formData.CustomerAddress" style="width:300px" size="small" @blur="changeAddress(formData.CustomerAddress,'InjuryAddress')"></el-input>
          </el-form-item>
          <el-form-item prop="InjuryAddress">
            <template #label>
              <span>发生事故地址（单位外）
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>详细地址精确到路名或者门牌号</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="formData.InjuryAddress" @blur="changeAddress(formData.InjuryAddress,'CustomerAddress')" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="工伤发生地（省市）" prop="WorkplaceInjuryPlace">
            <el-cascader ref="regAddress" :props="propsAddress" v-model="city" :options="provinces" placeholder="" filterable size="small" style="width:300px" @change="changeCity" clearable></el-cascader>
          </el-form-item>

          <el-form-item label="大致费用" prop="ApproximateCost">
            <el-input v-model="formData.ApproximateCost" type="number" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item prop="FullNameFirstHospital">
            <template #label>
              <span>首次就诊医院全称
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>温馨提醒：商保就诊医院要求二级（含）以上公立医院</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="formData.FullNameFirstHospital" style="width:300px" size="small" @blur="getInjuryDetails"></el-input>
          </el-form-item>
          <el-form-item prop="Diagnosis">
            <template #label>
              <span>诊断结论
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>按照医院出具的“诊断证明书”上的内容进行填写</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="formData.Diagnosis" style="width:300px" size="small" @blur="getInjuryDetails"></el-input>
          </el-form-item>
          <el-form-item label="医生建议" prop="DoctorAdvice">
            <el-input v-model="formData.DoctorAdvice" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="是否住院" prop="IsHospitalized">
            <el-select v-model="formData.IsHospitalized" placeholder="" clearable size="small" style="width:300px">
              <el-option value="是"></el-option>
              <el-option value="否"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工伤发生时岗位" prop="PositionInjury">
            <el-input v-model="formData.PositionInjury" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="商保参保时岗位" prop="InsurePosition">
            <el-input v-model="formData.InsurePosition" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="商保参保时职业类别" prop="InsureCategory">
            <el-select v-model="formData.InsureCategory" placeholder="" clearable size="small" style="width:300px">
              <el-option value="无"></el-option>
              <el-option value="1-4类"></el-option>
              <el-option value="5类"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="工伤程度" prop="InjuryDegree">
            <el-select v-model="formData.InjuryDegree" placeholder="" clearable size="small" style="width:300px">
              <el-option value="有骨折"></el-option>
              <el-option value="无骨折"></el-option>
              <el-option value="无骨折，预计有伤残等级"></el-option>
              <el-option value="死亡"></el-option>
              <el-option value="非以上情况"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否上下班途中交通事故" prop="IsTrafficInjury">
            <el-select v-model="formData.IsTrafficInjury" placeholder="" clearable size="small" style="width:300px">
              <el-option value="是"></el-option>
              <el-option value="否"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="交通事故员工责任判定">
            <el-select v-model="formData.LiabilityJudTrafficInjury" placeholder="" clearable size="small" style="width:300px">
              <el-option value="员工无责"></el-option>
              <el-option value="员工次责"></el-option>
              <el-option value="员工同责"></el-option>
              <el-option value="责任未出具"></el-option>
              <el-option value="无需出具"></el-option>
            </el-select>
          </el-form-item>

          <div>
            <el-form-item label="第一申报方（社保全称）" prop="FullNameSocialSecurity">
              <el-select v-model="formData.FullNameSocialSecurity" placeholder="" clearable size="small" style="width:300px" filterable @change="changeFullNameSocialSecurity">
                <el-option value="无"></el-option>
                <el-option v-for="(item,index) in accountList" :key="index" :value="item.accountFullName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <template #label>
                <span>参保时间
                  <el-tooltip placement="top" effect="light">
                    <div slot="content">
                      <div>“工伤发生前”最近一次参保时间</div>
                    </div>
                    <i class="el-icon-question cp"></i>
                  </el-tooltip>
                </span>
              </template>
              <el-date-picker type="date" placeholder="" v-model="formData.InInsureTime" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
            </el-form-item>
          </div>
          <el-form-item label="第二申报方（商保1）" prop="SecondApplicant">
            <el-select v-model="formData.SecondApplicant" placeholder="" clearable size="small" style="width:300px" @change="changeSecondApplicant">
              <el-option value="无"></el-option>
              <el-option v-for="(item,index) in insureList" :key="index" :value="item.Bntype"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <template #label>
              <span>参保时间
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>“工伤发生前”最近一次参保时间</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-date-picker type="date" placeholder="" v-model="formData.InInsureTime2" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="第三申报方（商保2）" prop="ThirdReporting">
            <el-select v-model="formData.ThirdReporting" placeholder="" clearable size="small" style="width:300px">
              <el-option value="无"></el-option>
              <el-option v-for="(item,index) in insureList" :key="index" :value="item.Bntype"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <template #label>
              <span>参保时间
                <el-tooltip placement="top" effect="light">
                  <div slot="content">
                    <div>“工伤发生前”最近一次参保时间</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-date-picker type="date" placeholder="" v-model="formData.InInsureTime3" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label="工伤事故报告备注">
            <el-input v-model="formData.Remark" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="工伤员工居住(收件)地址">
            <el-input v-model="formData.InjuryEmpAddress" style="width:300px" size="small"></el-input>
          </el-form-item>
          <div class="injuryTextarea">
            <el-form-item prop="AccidentProcess">
              <template #label>
                <span>受伤害经过简述
                  <el-tooltip placement="top" effect="light">
                    <div slot="content" style="width:300px">
                      <div>应写明事故发生时所从事的工作，受伤害的原因以及伤害部位和程度。例如：在车间拉设灯线时，不慎摔倒在地，右手指和大拇指受伤。立即送往医院就诊。</div>
                    </div>
                    <i class="el-icon-question cp"></i>
                  </el-tooltip>
                </span>
              </template>
              <el-input v-model="formData.AccidentProcess" style="width:300px" size="small" type="textarea" maxlength="200" placeholder="在车间拉设灯线时，不慎摔倒在地，右手指和大拇指受伤。立即送往医院就诊。" @blur="getInjuryDetails" :autosize="{ minRows: 3}" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="事故经过" prop="InjuryDetails">
              <el-input v-model="formData.InjuryDetails" placeholder="无需填写，自动生成" style="width:300px" size="small" type="textarea" maxlength="200" :autosize="{ minRows: 5}" show-word-limit></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAdd = false" size="small">取 消</el-button>
        <el-button type="warning" v-preventReClick style="margin-left:10px;" size="small" @click="previewHandle">预览</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="saveDraft" :loading="isBtnLoading">保存为草稿</el-button>
        <el-button type="success" v-preventReClick style="margin-left:10px;" size="small" @click="confirmSubmit" :loading="isBtnLoading">提 交</el-button>
      </span>
    </el-dialog>

    <div class="dialogBox">
      <el-dialog title="预览" :visible.sync="showPreview" width="800px">
        <div class="previewTitle">工伤事故报告（杰博留存）</div>
        <div class="previewBox">
          <div class="previewContent">

            <div class="form-item">
              <label>第一申报方（社保全称）:</label>
              <span>{{ formData.FullNameSocialSecurity ? formData.FullNameSocialSecurity : '无' }}</span>
            </div>
            <div class="form-item">
              <label>第一申报方（社保全称）参保时间:</label>
              <span>{{ formData.InInsureTime ? formData.InInsureTime : '无' }}</span>
            </div>
            <div class="form-item">
              <label>第二申报方（商保1）:</label>
              <span>{{ formData.SecondApplicant ? formData.SecondApplicant : '无' }}</span>
            </div>
            <div class="form-item">
              <label>第二申报方（商保1）参保时间:</label>
              <span>{{ formData.InInsureTime2 ? formData.InInsureTime2.replace('T',' ') : '无' }}</span>
            </div>

            <div class="form-item">
              <label>第三申报方（商保2）:</label>
              <span>{{ formData.ThirdReporting ? formData.ThirdReporting : '无' }}</span>
            </div>
            <div class="form-item">
              <label>第三申报方（商保2）参保时间:</label>
              <span>{{ formData.InInsureTime3 ? formData.InInsureTime3.replace('T',' ') : '无' }}</span>
            </div>

            <div class="form-item">
              <label>身份证号码:</label>
              <span>{{ formData.Idcard ? formData.Idcard : '无' }}</span>
            </div>
            <div class="form-item">
              <label>工伤员工姓名:</label>
              <span>{{ formData.InjuredEmployeeName ? formData.InjuredEmployeeName : '无' }}</span>
            </div>
            <div class="form-item">
              <label>项目名称:</label>
              <span>{{ formData.ProjectName ? formData.ProjectName : '无' }}</span>
            </div>
            <div class="form-item">
              <label>客户单位全称:</label>
              <span>{{ formData.FullNameCustomer ? formData.FullNameCustomer : '无' }}</span>
            </div>
            <div class="form-item">
              <label>立项归属公司:</label>
              <span>{{ formData.BranchOffice ? formData.BranchOffice : '无' }}</span>
            </div>

            <div class="form-item">
              <label>主商务合同（法务主体）全称:</label>
              <span>{{ formData.MainBusiContract ? formData.MainBusiContract : '无' }}</span>
            </div>
            <div class="form-item">
              <label>劳动合同公司:</label>
              <span>{{ formData.PartyLaborContract ? formData.PartyLaborContract : '无' }}</span>
            </div>
            <div class="form-item">
              <label>发生工伤日期:</label>
              <span>{{ formData.TimeInjury ? formData.TimeInjury : '无' }}</span>
            </div>
            <div class="form-item">
              <label>发生工伤时间:</label>
              <span>{{ formData.TimeInjury1 ? formData.TimeInjury1 : '无' }}</span>
            </div>
            <div class="form-item">
              <label>员工联系电话:</label>
              <span>{{ formData.EmployeePhone ? formData.EmployeePhone : '无' }}</span>
            </div>
            <div class="form-item">
              <label>员工学历:</label>
              <span>{{ formData.EmployeeEduc ? formData.EmployeeEduc : '无' }}</span>
            </div>
            <div class="form-item">
              <label>发生事故地址（单位内）:</label>
              <span>{{ formData.CustomerAddress ? formData.CustomerAddress : '无' }}</span>
            </div>
            <div class="form-item">
              <label>发生事故地址（单位外）:</label>
              <span>{{ formData.InjuryAddress ? formData.InjuryAddress : '无' }}</span>
            </div>
            <div class="form-item">
              <label>工伤发生地（省市）:</label>
              <span>{{ formData.WorkplaceInjuryPlace ? formData.WorkplaceInjuryPlace : '无' }}</span>
            </div>
            <div class="form-item">
              <label>大致费用:</label>
              <span>{{ formData.ApproximateCost ? formData.ApproximateCost : '无' }}</span>
            </div>
            <div class="form-item">
              <label>首次就诊医院全称:</label>
              <span>{{ formData.FullNameFirstHospital ? formData.FullNameFirstHospital : '无' }}</span>
            </div>
            <div class="form-item">
              <label>诊断结论:</label>
              <span>{{ formData.Diagnosis ? formData.Diagnosis : '无' }}</span>
            </div>
            <div class="form-item">
              <label>医生建议:</label>
              <span>{{ formData.DoctorAdvice ? formData.DoctorAdvice : '无' }}</span>
            </div>
            <div class="form-item">
              <label>是否住院:</label>
              <span>{{ formData.IsHospitalized ? formData.IsHospitalized : '无' }}</span>
            </div>
            <div class="form-item">
              <label>工伤发生时岗位:</label>
              <span>{{ formData.PositionInjury ? formData.PositionInjury : '无' }}</span>
            </div>
            <div class="form-item">
              <label>商保参保时岗位:</label>
              <span>{{ formData.InsurePosition ? formData.InsurePosition : '无' }}</span>
            </div>
            <div class="form-item">
              <label>商保参保时职业类别:</label>
              <span>{{ formData.InsureCategory ? formData.InsureCategory : '无' }}</span>
            </div>
            <div class="form-item">
              <label>工伤程度:</label>
              <span>{{ formData.InjuryDegree ? formData.InjuryDegree : '无' }}</span>
            </div>
            <div class="form-item">
              <label>是否上下班途中交通事故:</label>
              <span>{{ formData.IsTrafficInjury ? formData.IsTrafficInjury : '无' }}</span>
            </div>
            <div class="form-item">
              <label>交通事故员工责任判定:</label>
              <span>{{ formData.LiabilityJudTrafficInjury ? formData.LiabilityJudTrafficInjury : '无' }}</span>
            </div>



            <div class="form-item">
              <label>工伤事故报告备注:</label>
              <span>{{ formData.Remark ? formData.Remark : '无' }}</span>
            </div>

            <div class="form-item">
              <label>受伤害经过简述:</label>
              <span>{{ formData.AccidentProcess ? formData.AccidentProcess : '无' }}</span>
            </div>

            <div class="form-item">
              <label>事故经过:</label>
              <span>{{ formData.InjuryDetails ? formData.InjuryDetails : '无' }}</span>
            </div>
          </div>
          <div class="form-item rightCont">
            <label>客服:</label>
            <span>{{ formData.Service ? formData.Service : '无' }}</span>
          </div>
          <div class="form-item rightCont">
            <label>客服联系电话:</label>
            <span>{{ formData.ServicePhone ? formData.ServicePhone : '无' }}</span>
          </div>
          <div class="form-item rightCont">
            <label>日期:</label>
            <span>{{ formData.CreateTime ? formData.CreateTime.replace('T',' ') : '无' }}</span>
          </div>
        </div>
      </el-dialog>
    </div>


    <el-dialog title="社保账户对应工伤负责人导入" :visible.sync="showImport" width="500px">
      <el-form label-width="100px">
        <el-form-item label="上传文件" prop="fileUrl">
          <el-upload class="upload-demo" action="" :on-remove="handleRemove" multiple :limit="1" :auto-upload="false" :on-exceed="handleExceed" :on-change="handleUpload" accept=".xlsx,.xls" :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showImport = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmImport()" :loading="isBtnLoading">确 认</el-button>
      </span>
    </el-dialog>

    <!-- 审批 -->
    <el-dialog title="审批确认" :visible.sync="showApprove" width="400px">
      <span>请确认是否通过审批？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showApprove = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmPass('pass')" size="small" :loading="isBtnLoading">确 认</el-button>
      </span>
    </el-dialog>

    <!-- 退回 -->
    <el-dialog title="退回" :visible.sync="showBack" width="500px">
      <div style="margin-bottom: 10px;">请确认是否退回？</div>
      <el-form>
        <el-form-item label="退回原因:">
          <el-input v-model="reasonReturn" style="width:300px" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showBack = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmPass('notpass')" size="small" :loading="isBtnLoading">确 认</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import moment from "moment";
  import xz from "../../common";
  import FUN from "../../fun";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      var validatetIdcard = (rule, value, callback) => {
        if (!this.formData.Idcard) {
          callback(new Error("请输入身份证号码"));
        } else if (this.formData.Idcard.length != 18) {
          callback(new Error("请输入正确的身份证号码"));
        } else {
          callback();
        }
        // else {
        //   this.getIdcardInfo(value, (res) => {
        //     console.log(res);
        //     if (res) {
        //       callback();
        //     } else {
        //       callback(new Error('该身份证号码未在花名册中'))
        //     }
        //   });
        // }
      };
      return {
        listQuery: {
          pageModel: {
            rows: 10,
            page: 1,
            orderInput: [{
              property: "submitTime",
              order: 1
            }],
          },
          busiStat: '1',
          idcard: '',
          injuredEmployeeName: '',
          projectName: '',
          employeePhone: '',
          timeInjury: '',
          startimeInjury: "",
          endimeInjury: ""
        },
        showDropScreen: -1,
        tableData: [],
        totalCount: 0,
        roletype: localStorage.loginRoletype,
        loading: false,
        showAdd: false,
        formData: {
          city: '',
          Id: '',
          Idcard: '', //身份证
          TimeInjury: '', //发生工伤时间（年-月-日）
          InjuredEmployeeName: '', //工伤员工姓名
          ProjectName: '', //项目名称
          Service: '', //客服
          ServicePhone: '', //客服联系电话
          BranchOffice: '', //立项归属公司
          MainBusiContract: '', //主商务合同（法务主体）全称
          TimeInjury1: '', //发生工伤时间点（几点几分）
          EmployeeEduc: '', //员工学历
          EmployeePhone: '', //员工联系电话
          FullNameCustomer: '', //客户单位全称
          CustomerAddress: '', //客户单位地址
          InjuryAddress: '', //发生事故地址
          PartyLaborContract: '', //劳动合同公司
          PositionInjury: '', //工伤发生时岗位
          InjuryDetails: '', //事故经过
          AccidentProcess: '', //受伤经过简述
          ApproximateCost: '', //大致费用
          FullNameFirstHospital: '', //首次就诊医院全称
          Diagnosis: '', //诊断结论
          DoctorAdvice: '', //医生建议
          InsurePosition: '', //商保参保时岗位
          InsureCategory: '', //商保参保时职业类别
          IsHospitalized: '', //是否住院
          InjuryDegree: '', //工伤程度
          IsTrafficInjury: '', //是否上下班途中交通事故
          LiabilityJudTrafficInjury: '', //交通事故员工的责任判定
          WorkplaceInjuryPlace: '', //工伤发生地（省市）
          FullNameSocialSecurity: '', //第一申报方（社保全称）
          InInsureTime: '', //参保时间1
          SecondApplicant: '', //第二申报方（商保1）
          InInsureTime2: '', //参保时间2
          ThirdReporting: '', //第三申报方（商保2）
          InInsureTime3: '', //参保时间3
          Remark: '', //工伤事故报告备注
          InjuryEmpAddress: '',
        },
        city: '',
        showPreview: false,
        isBtnLoading: false,
        rules: {
          Idcard: {
            required: true,
            // message: '请输入身份证',
            trigger: 'blur',
            validator: validatetIdcard,
          },
          TimeInjury: {
            required: true,
            message: '请选择发生工伤时间（年-月-日）',
            trigger: 'change'
          },
          InjuredEmployeeName: {
            required: true,
            message: '请输入工伤员工姓名',
            trigger: 'blur'
          },
          ProjectName: {
            required: true,
            message: '请选择项目名称',
            trigger: 'change'
          },
          Service: {
            required: true,
            message: '请输入客服',
            trigger: 'blur'
          },
          ServicePhone: {
            required: true,
            message: '请输入客服联系电话',
            trigger: 'blur'
          },
          BranchOffice: {
            required: true,
            message: '请输入立项归属公司',
            trigger: 'blur'
          },
          MainBusiContract: {
            required: true,
            message: '请输入主商务合同（法务主体）全称',
            trigger: 'blur'
          },
          TimeInjury1: {
            required: true,
            message: '请选择发生工伤时间点（几点几分）',
            trigger: 'change'
          },
          EmployeeEduc: {
            required: true,
            message: '请输入员工学历',
            trigger: 'blur'
          },
          EmployeePhone: {
            required: true,
            message: '请输入员工联系电话',
            trigger: 'blur'
          },
          FullNameCustomer: {
            required: true,
            message: '请输入客户单位全称',
            trigger: 'blur'
          },
          CustomerAddress: {
            required: true,
            message: '请输入客户单位地址',
            trigger: 'blur'
          },
          InjuryAddress: {
            required: true,
            message: '请输入发生事故地址',
            trigger: 'blur'
          },
          PartyLaborContract: {
            required: true,
            message: '请输入劳动合同公司',
            trigger: 'blur'
          },
          PositionInjury: {
            required: true,
            message: '请输入工伤发生时岗位',
            trigger: 'blur'
          },
          InjuryDetails: {
            required: true,
            message: '请输入事故经过',
            trigger: 'blur'
          },
          AccidentProcess: {
            required: true,
            message: '请输入受伤经过简述',
            trigger: 'blur'
          },
          ApproximateCost: {
            required: true,
            message: '请输入大致费用',
            trigger: 'blur'
          },
          FullNameFirstHospital: {
            required: true,
            message: '请输入首次就诊医院全称',
            trigger: 'blur'
          },
          Diagnosis: {
            required: true,
            message: '请输入诊断结论',
            trigger: 'blur'
          },
          DoctorAdvice: {
            required: true,
            message: '请输入医生建议',
            trigger: 'blur'
          },
          InsurePosition: {
            required: true,
            message: '请输入商保参保时岗位',
            trigger: 'blur'
          },
          InsureCategory: {
            required: true,
            message: '请输入商保参保时职业类别',
            trigger: 'blur'
          },
          IsHospitalized: {
            required: true,
            message: '请选择是否住院',
            trigger: 'change'
          },
          InjuryDegree: {
            required: true,
            message: '请选择工伤程度',
            trigger: 'change'
          },
          IsTrafficInjury: {
            required: true,
            message: '请选择是否上下班途中交通事故',
            trigger: 'change'
          },
          LiabilityJudTrafficInjury: {
            required: true,
            message: '请选择交通事故员工的责任判定',
            trigger: 'change'
          },
          WorkplaceInjuryPlace: {
            required: true,
            message: '请选择工伤发生地（省市）',
            trigger: 'change'
          },
          FullNameSocialSecurity: {
            required: true,
            message: '请输入第一申报方（社保全称）',
            trigger: 'blur'
          },
          InInsureTime: {
            required: true,
            message: '请选择参保时间1',
            trigger: 'change'
          },
          SecondApplicant: {
            required: true,
            message: '请选择第二申报方（商保1）',
            trigger: 'change'
          },
          InInsureTime2: {
            required: true,
            message: '请选择参保时间2',
            trigger: 'change'
          },
          ThirdReporting: {
            required: true,
            message: '请选择第三申报方（商保2）',
            trigger: 'change'
          },
          InInsureTime3: {
            required: true,
            message: '请选择参保时间3',
            trigger: 'change'
          },
          Remark: {
            required: true,
            message: '请输入工伤事故报告备注',
            trigger: 'blur'
          },
        },
        provinces: [], //省列表
        propsAddress: {
          label: "Name",
          value: "Name",
          children: "children"
        },
        insureList: [], //险种列表
        proNameList: [], //项目列表
        legList: [], //
        legList2: [], //劳动合同公司下拉列表
        type: '',
        fileList: [],
        showImport: false,
        fileUrl: '',
        activeName: '1',
        iscustomerService: false,
        isinsura: false,
        isocial: false,
        num0: 0,
        num1: 0,
        num2: 0,
        num3: 0,
        num4: 0,
        num5: 0,
        num6: 0,
        num7: 0,
        accountList: [],
        info: {},
        showApprove: false,
        reasonReturn: '',
        showBack: false,
        permissionLists: [],
      }
    },
    created() {
      this.getButtonPower();
      this.getProList();
      this.getAccountList();
      this.getprovinces();
      this.getInsurancManageByUserid();
      this.getList();
      this.getlegalsubjectlist();
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let d = {
          path: '/acdReport',
          powerEnName: 'acdReport'
        }
        xz.getbtnPowerIdBypage(d).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (resmsg != undefined && resmsg.length > 0) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
            } else {
              this.permissionLists = []
            }
          } else {
            this.permissionLists = []
          }
        })
      },
      //获取省市区
      getprovinces() {
        xz.getAreaAll().then((res) => {
          if (res != undefined && res.length > 0) {
            res.forEach(element => {
              if (element.children != undefined && element.children.length > 0) {
                element.children.forEach(e => {
                  delete e.children
                })
              }
            });
            this.provinces = res
          }
        })
      },
      //获取账户列表
      getAccountList() {
        let d = {
          PageModel: {
            Rows: 10000,
            Page: 1,
            OrderInput: []
          },
        }
        xz.SocialFun(d, 'GetSocialSettingsPageList', 'post').then(res => {
          if (res.status == 'ok') {
            this.accountList = res.data.data;;
          } else {
            this.accountList = [];
          }
        })
      },
      //获取商保险种
      getInsurancManageByUserid() {
        let data = {
          pageNum: 1,
          pageSize: 1000
        }
        xz.getInsurancManageByUserid(data, this.roletype).then((res) => {
          if (res.status == "ok") {
            this.insureList = res.data.list;
          } else {
            this.insureList = [];
          }
        })
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      //选择省市
      changeCity() {
        this.formData.WorkplaceInjuryPlace = this.city.toString().replace(',', '-')
      },
      currentChange(val) {
        this.listQuery.pageModel.page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageModel.page = 1;
        this.listQuery.pageModel.rows = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.pageModel.page = 1;
        this.getList();
      },
      getList() {
        this.loading = true;
        this.loading = true;
        xz.ArdCurStat(this.listQuery, 'getWIAccidentReportList').then(res => {
          if (res.status == "ok") {
            this.tableData = res.data.result.data;
            this.totalCount = res.data.result.pageModel.totalCount;
            this.loading = false;
            this.iscustomerService = res.data.iscustomerService;
            this.isinsura = res.data.isinsura;
            this.isocial = res.data.isocial;
            this.num0 = 0;
            this.num1 = 0;
            this.num2 = 0;
            this.num3 = 0;
            this.num4 = 0;
            this.num5 = 0;
            this.num6 = 0;
            this.num7 = 0;
            this.num5 = res.data.customerServiceCount;
            this.num6 = res.data.insuraApproveCount;
            this.num7 = res.data.socialSecuApproveCount;
            if (res.data.groupByCount.length > 0) {
              res.data.groupByCount.forEach(e => {
                if (e.value == 0) {
                  this.num0 = e.count
                } else if (e.value == 1) {
                  this.num1 = e.count
                } else if (e.value == 3) {
                  this.num3 = e.count
                } else if (e.value == 4) {
                  this.num4 = e.count
                } else if (e.value == 5) {
                  this.num2 = e.count
                }
              });
            }

          } else {
            this.loading = false;
            this.tableData = [];
          }
        })
      },
      //新增事故报告
      addNewAcd() {
        this.clearForm();
        this.type = 'add';
        this.formData.Service = localStorage.userName;
        this.formData.ServicePhone = localStorage.strmobile;
        this.showAdd = true;
      },
      editAcd(item) {
        this.type = 'edit';
        xz.getWIAccidentReport(item.id, this.roletype).then(res => {
          if (res.status == "ok") {
            this.formData = res.data;
            this.city = res.data.WorkplaceInjuryPlace.split('-');
          } else {
            this.formData = item;
            this.city = item.WorkplaceInjuryPlace.split('-');
          }
          this.showAdd = true;
        })
      },
      clearForm() {
        this.city = '';
        this.isBtnLoading = false;
        this.formData = {
          Id: '',
          Idcard: '', //身份证
          TimeInjury: '', //发生工伤时间（年-月-日）
          InjuredEmployeeName: '', //工伤员工姓名
          ProjectName: '', //项目名称
          Service: '', //客服
          ServicePhone: '', //客服联系电话
          BranchOffice: '', //立项归属公司
          MainBusiContract: '', //主商务合同（法务主体）全称
          TimeInjury1: '', //发生工伤时间点（几点几分）
          EmployeeEduc: '', //员工学历
          EmployeePhone: '', //员工联系电话
          FullNameCustomer: '', //客户单位全称
          CustomerAddress: '', //客户单位地址
          InjuryAddress: '', //发生事故地址
          PartyLaborContract: '', //劳动合同公司
          PositionInjury: '', //工伤发生时岗位
          InjuryDetails: '', //事故经过
          AccidentProcess: '', //受伤经过简述
          ApproximateCost: '', //大致费用
          FullNameFirstHospital: '', //首次就诊医院全称
          Diagnosis: '', //诊断结论
          DoctorAdvice: '', //医生建议
          InsurePosition: '', //商保参保时岗位
          InsureCategory: '', //商保参保时职业类别
          IsHospitalized: '', //是否住院
          InjuryDegree: '', //工伤程度
          IsTrafficInjury: '', //是否上下班途中交通事故
          LiabilityJudTrafficInjury: '', //交通事故员工的责任判定
          WorkplaceInjuryPlace: '', //工伤发生地（省市）
          FullNameSocialSecurity: '', //第一申报方（社保全称）
          InInsureTime: '', //参保时间1
          SecondApplicant: '', //第二申报方（商保1）
          InInsureTime2: '', //参保时间2
          ThirdReporting: '', //第三申报方（商保2）
          InInsureTime3: '', //参保时间3
          Remark: '', //工伤事故报告备注
          InjuryEmpAddress: ''
        }
      },
      preview(row) {
        xz.getWIAccidentReport(row.id, this.roletype).then(res => {
          if (res.status == "ok") {
            this.formData = res.data;
            this.city = res.data.WorkplaceInjuryPlace.split('-');
          } else {
            this.formData = row;
            this.city = row.WorkplaceInjuryPlace.split('-');
          }
          this.showPreview = true;
        })
      },
      previewHandle() {
        this.showPreview = true;
      },
      //新增/修改
      confirmSubmit() {
        this.$refs["formData"].validate((valid) => {
          if (valid) {
            this.isBtnLoading = true
            this.formData.BusiStat = 1;
            xz.updataWIAccidentReport(this.formData, this.roletype).then(res => {
              if (res.status == "ok") {
                this.showAdd = false;
                this.isBtnLoading = false
                this.getList();
                this.$message.success('新增成功！')
              } else {
                this.isBtnLoading = false
                this.$message.error(res.msg)
              }
            })
          } else {
            this.$message.error('请填写必填项！')
          }
        })
      },
      saveDraft() {
        this.isBtnLoading = true;
        this.formData.BusiStat = 0;
        xz.updataWIAccidentReport(this.formData, this.roletype).then(res => {
          if (res.status == "ok") {
            this.showAdd = false;
            this.isBtnLoading = false
            this.getList();
            this.$message.success('新增成功！')
          } else {
            this.isBtnLoading = false
            this.$message.error(res.msg)
          }
        })
      },
      delAcd(item) {
        xz.delWIAccidentReport(item.id, this.roletype).then(res => {
          if (res.status == "ok") {
            this.getList();
            this.$message.success('作废成功！')
          } else {
            this.getList();
            this.$message.error(res.msg)
          }
        })
      },
      //导出报告
      getReport(row) {
        xz.exportInjuryReport(row.id, this.roletype).then(res => {
          if (res.status == "ok") {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a")
            aLink.download = `${row.projectName}-${row.injuredEmployeeName}-工伤事故报告-${row.timeInjury} ${row.timeInjury1}-${row.service}.zip` //这里写保存时的图片名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let data = {
          pageNum: '1',
          pageSize: '10000'
        }
        xz.getlegalsubjectlist(data).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.data;
            const excludedCompanies = [
              "无锡杰博人力资源有限公司",
              "杰博人力资源(西安)有限公司",
              "上海才服企业管理咨询有限公司",
              "杰博(重庆)人力资源服务有限公司",
              "南通市杰博人力资源有限公司"
            ];

            // 过滤掉 companyName 在 excludedCompanies 中的数据
            this.legList2 = res.data.data.filter(item => !excludedCompanies.includes(item.companyName));
          } else {
            this.legList = [];
            this.legList2 = [];
          }
        })
      },
      //根据身份证号获取信息
      getIdcardInfo(chkval, callback) {
        if (this.formData.Idcard.length == 18) {
          let str = `?strIdCard=${this.formData.Idcard}`
          xz.ArdCurStatGetFun('GetWorkInjuryReportEmployeeInfo', str).then(res => {
            if (res.status == "ok") {
              if (res.data.strEmpName != undefined && res.data.strEmpName && this.formData.InjuredEmployeeName != res.data.strEmpName) {
                this.formData.InjuredEmployeeName = res.data.strEmpName;
                this.formData.ProjectName = res.data.strObjName;
                this.formData.EmployeeEduc = res.data.strEduLv;
                this.formData.BranchOffice = res.data.belongCompany;
                // this.formData.Service = res.data.strUserName;
                this.formData.EmployeePhone = res.data.strPhoneNum;
                this.formData.InsurePosition = res.data.jobName;
                this.formData.InsureCategory = res.data.jobClasss;
                this.formData.SecondApplicant = res.data.insuranceName;
                this.formData.FullNameCustomer = res.data.strCustName;
                this.formData.PartyLaborContract = res.data.contractCompanyName;
                this.formData.InInsureTime2 = moment(res.data.coverStartTime).format('YYYY-MM-DD');
                // this.formData.ServicePhone = res.data.customerServiceHotline;
                this.$message.success('已自动填充员工信息，请核对！')
                // callback(true)
              } else {
                // callback(true);
              }
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      },
      getInjuryDetails() {
        if (this.formData.Idcard && this.formData.InjuredEmployeeName && this.formData.TimeInjury1 && this.formData.TimeInjury && this.formData.FullNameFirstHospital && this.formData.Diagnosis && this.formData.AccidentProcess) {
          this.formData.InjuryDetails = `员工姓名${this.formData.InjuredEmployeeName}，身份证号码为${this.formData.Idcard}，于${this.formData.TimeInjury}日${this.formData.TimeInjury1}左右，${this.formData.AccidentProcess}。首次就诊医院为${this.formData.FullNameFirstHospital}，诊断结果为${this.formData.Diagnosis}。`
        }
      },
      //导入
      ImportSocialCompanyName() {
        this.isBtnLoading = false;
        this.fileList = [];
        this.showImport = true;
      },
      handleUpload(file) {
        const formData = new FormData();
        formData.append("pagename", "empexcel");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.fileUrl = res;
          } else {
            this.fileUrl = ''
          }
        });
      },
      handleRemove() {
        this.fileUrl = '';
        this.fileList = [];
      },
      handleExceed() {
        this.$message.warning(`最多上传 1 个文件，请先删除再上传`);
      },
      confirmImport() {
        if (this.fileUrl) {
          let d = {
            fileUrl: this.fileUrl
          }
          xz.ArdCurStat(d, 'ImportSocialCompanyName').then(res => {
            if (res.status == 'ok') {
              this.$message.success('导入成功！');
              this.isBtnLoading = false;
              this.showImport = false;
            } else {
              this.$message.error(res.msg);
              this.isBtnLoading = false;
            }
          })
        }
      },
      changeTab() {
        if (this.activeName == '5') {
          this.listQuery.busiStat = '2';
          this.listQuery.iscustomerService = true;
          this.listQuery.insuraApprove = false;
          this.listQuery.socialSecuApprove = false;
        } else if (this.activeName == '6') {
          this.listQuery.busiStat = '2';
          this.listQuery.iscustomerService = false;
          this.listQuery.insuraApprove = true;
          this.listQuery.socialSecuApprove = false;
        } else if (this.activeName == '7') {
          this.listQuery.busiStat = '2';
          this.listQuery.iscustomerService = false;
          this.listQuery.insuraApprove = false;
          this.listQuery.socialSecuApprove = true;
        } else if (this.activeName == '2') {
          this.listQuery.busiStat = '5';
          this.listQuery.iscustomerService = null;
          this.listQuery.insuraApprove = null;
          this.listQuery.socialSecuApprove = null;
        } else {
          this.listQuery.busiStat = this.activeName;
          this.listQuery.iscustomerService = null;
          this.listQuery.insuraApprove = null;
          this.listQuery.socialSecuApprove = null;
        }
        if (this.activeName == '4') {
          this.listQuery.pageModel.orderInput = [{
            property: "updataTime",
            order: 1
          }]
        } else {
          this.listQuery.pageModel.orderInput = [{
            property: "submitTime",
            order: 1
          }]
        }
        this.getList();
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      //提交
      submitHandle(row) {
        this.loading = true;
        let d = {
          busiType: 7,
          id: row.id,
          reasonReturn: '',
        }
        this.confirmHandle(d)
      },
      //申请修改
      applyEdit(row) {
        this.loading = true;
        let str = `?Id=${row.id}`
        xz.ArdCurStatGetFun('WIAccidentReportApplyModifiy', str).then(res => {
          if (res.status == 'ok') {
            this.$message.success('申请成功！');
            this.loading = false;
            this.getList();
          } else {
            this.$message.error(res.msg);
            this.getList();
            this.loading = false;
          }
        })
      },
      changeAddress(val, type) {
        if (val) {
          this.formData[type] = '无';
          if (type == 'InjuryAddress') {
            this.formData.IsTrafficInjury = '否'
          }
        }
      },
      approveHandle(row, type) {
        this.info = row;
        this.isBtnLoading = false;
        if (type == 'pass') {
          this.showApprove = true;
        } else {
          this.reasonReturn = '';
          this.showBack = true;
        }
      },
      confirmPass(type) {
        this.isBtnLoading = true;
        let busiType;
        if (type == 'pass') {
          busiType = this.activeName == '5' ? 1 : this.activeName == '6' ? 2 : this.activeName == '7' ? 3 : 4
        } else {
          busiType = this.activeName == '3' ? 5 : 6
        }
        let d = {
          busiType: busiType,
          id: this.info.id,
          reasonReturn: type == 'notpass' ? this.reasonReturn : '',
        }
        this.confirmHandle(d)
      },
      confirmHandle(d) {
        xz.ArdCurStat(d, 'WIAccidentReportApprove').then(res => {
          if (res.status == 'ok') {
            this.$message.success(this.activeName == '3' ? '操作成功！' : '审批成功！');
            this.isBtnLoading = false;
            this.getList();
            this.showApprove = false;
            this.showBack = false;
          } else {
            this.$message.error(res.msg);
            this.getList();
            this.isBtnLoading = false;
            this.showBack = false;
          }
        })
      },
      expList() {
        let pagename = 'EgetWIAccidentReportListList';
        this.isExping = true;
        let d = JSON.parse(JSON.stringify(this.listQuery));
        xz.ArdCurStatExp(d, pagename).then(res => {
          if (res) {
            try {
              var data = new Blob([res], {
                type: "application/vnd.ms-excel;charset=utf-8"
              });
              var downloadUrl = window.URL.createObjectURL(data);
              var anchor = document.createElement("a");
              anchor.href = downloadUrl;
              anchor.download = "审批完成列表导出.xlsx";
              anchor.click();
              window.URL.revokeObjectURL(data);
              this.isExping = false;
            } catch (e) {
              this.isExping = false;
              this.$message.error('导出异常')
            }
          } else {
            this.isExping = false;
            this.$message.error('导出异常')
          }
        })
      },
      changeFullNameSocialSecurity() {
        if (val && !this.formData.SecondApplicant) {
          this.formData.SecondApplicant = '无';
        }
      },
      changeSecondApplicant(val) {
        if (val && !this.formData.ThirdApplicant) {
          this.formData.ThirdReporting = '无';
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .agg {
    font-weight: 600;
  }

  .tipsItem {
    margin-top: 10px;
  }

  .previewTitle {
    font-size: 32px;
    font-weight: 600;
    font-family: 宋体;
    text-align: center;
    margin-bottom: 15px;
  }

  .previewBox {
    font-size: 17px;
    font-family: 宋体;
  }

  .previewContent {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .form-item {
    margin-bottom: 10px;
  }

  .form-item label {
    color: #000;
  }

  .form-item span {
    color: #000;
    margin-left: 5px;
  }

  .rightCont {
    text-align: right;
    margin-right: 20px;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }
</style>
<style>
  .page_injuryTables .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_injuryTables .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_injuryTables .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_injuryTables .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_injuryTables .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_injuryTables .formData .el-form-item {
    margin-bottom: 10px;
  }

  .page_injuryTables .formData .el-form-item__error {
    top: 34px;
  }

  .page_injuryTables .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_injuryTables .formData .el-icon-question:before {
    color: #F56C6C;
  }

  .page_injuryTables .formData .injuryTextarea .el-form-item__error {
    top: 75px;
  }

  .page_injuryTables .dialogBox .el-dialog__body {
    padding: 10px 20px;
  }

  .page_injuryTables .el-table__fixed-body-wrapper {
    border: 0;
  }

  .page_injuryTables .el-table__fixed-body-wrapper {
    top: 45px !important;
  }
</style>